import { render, staticRenderFns } from "./BusinessInEkiti.vue?vue&type=template&id=dbbc6a9c&scoped=true"
import script from "./BusinessInEkiti.vue?vue&type=script&lang=js"
export * from "./BusinessInEkiti.vue?vue&type=script&lang=js"
import style0 from "./BusinessInEkiti.vue?vue&type=style&index=0&id=dbbc6a9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc6a9c",
  null
  
)

export default component.exports